import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowTopLeftFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M9.25 1C10.7688 1 12 2.23122 12 3.75V8.25C12 9.76878 10.7688 11 9.25 11H2.75C1.23122 11 0 9.76878 0 8.25V3.75C0 2.23122 1.23122 1 2.75 1H9.25ZM2.75 3C2.33579 3 2 3.33579 2 3.75V5.75C2 6.16421 2.33579 6.5 2.75 6.5H4.75C5.16421 6.5 5.5 6.16421 5.5 5.75V3.75C5.5 3.33579 5.16421 3 4.75 3H2.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowTopLeftFill12.js.map